import { jsx as _jsx } from "react/jsx-runtime";
import { InputAdornment } from './Input.styled.js';
export const useCustomClassName = (success = false, size = 'sm', className = '') => {
    const successClassName = success ? 'input-success' : '';
    const sizeClassName = size === 'md' ? 'input-md' : 'input-sm';
    const customClassName = [successClassName, sizeClassName, className]
        .join(' ')
        .trim();
    return customClassName || undefined;
};
export const useAdornments = (startAdornment, endAdornment) => ({
    wrappedStartAdornment: startAdornment ? (_jsx(InputAdornment, { className: "input-adornment-start", children: startAdornment })) : undefined,
    wrappedEndAdornment: endAdornment ? (_jsx(InputAdornment, { className: "input-adornment-end", children: endAdornment })) : undefined,
});
